export const minimumSession =
    parseInt(window.sessions?.minimum_session_time, 10) || 15;
export const maximumSession =
    parseInt(window.sessions?.maximum_session_time, 10) || 60;
export const sessionQuestionTimer =
    parseInt(window.timer?.countdown_timer, 10) || 60;
export const standardSessionTime =
    (maximumSession - minimumSession) / 2 + minimumSession;
